import React, { useContext, useRef } from 'react';

import {
  CALCULATE_PREMIUM_FOR_PROPOSAL_TW,
  FINANCER_DROPDOWN_DETAILS,
  GET_BUY_HEALTH_POLICY_VAR_DETAILS,
  PREVIOUS_INSURER_COMPANY_LIST,
 
  
} from '../queries';
import { CALCULATE_PREMIUM_FOR_PROPOSAL } from '../queries';
import moment from 'moment';
//import { GET_BUY_HEALTH_POLICY_VAR_DETAILS } from '../queries';
import { Loading } from 'quanta-flows/modules/layout';
//import Error from '../../../../../lib/layout/error';
import { Error } from 'quanta-flows/modules/layout';
import { useQuery } from '@apollo/client';
import { QuantaConfigContext } from 'quanta-flows';
import {
  useResponsiveParams,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  Text,
  MixedGridGroup,
  QuantaInput,
  QuantaSelect,
} from 'quanta-ui';
//import Parse from '../../../../../lib/intl/CurrencyFormater';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  
  faRupeeSign,
  
} from '@fortawesome/free-solid-svg-icons';
import { CurrencyFormater } from 'quanta-flows';
import { PROPOSER_DROPDOWN_DETAIL } from '../queries';

import { updateBuyHealthPolicy } from 'quanta-flows/modules/proposal/health/state';
import { updateBuyMotorPolicy } from '../_graphql/state';
import {useFetchQuery} from 'quanta-flows';
//import { i } from 'quanta-flows/modules/_rollupPluginBabelHelpers-fb970440';
//import useFetchQuery from '';
import { useParams } from 'react-router-dom';

export default function AdditionalDetails({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  setCustomLoadingMessage,
  setLoadingStep,
  productCode,
  productName,
  lobCode,
  lobName,
  productType,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  const { branding } = useContext(QuantaConfigContext);
  const repeatForDesktop = 3,
    repeatForMobile = 2;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  const initLoadRef = useRef([]);
  const params = useParams();
  //const plan_name = planName ? planName : params?.plan_name;
  //const plan_code = planCode ? planCode : params?.plan_code;
  const product_code = "3153"
  let prdcode = "2880";
  const { loading: loadingdrop, data: dropDownDetails } = useQuery(

    PROPOSER_DROPDOWN_DETAIL,

    {

      fetchPolicy: 'cache-first',

      variables: {

        productCode: prdcode,

      },
      onCompleted: (_) => {
        initLoadRef.current = [...initLoadRef.current, 2];
      },
    },

  );
  
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toLowerCase() ===
        searchText?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toLowerCase() ===
            searchText?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const {
    loading,
    error,
    data: dataBuyMotorPolicy,
    previousData,
  } = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: new Set(initLoadRef.current).size >= 3,
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });
  ////console.log('111_dataBuyMotorPolicy',dataBuyMotorPolicy)
  
  //const { buyMotorPolicy } = dataBuyMotorPolicy
//   const {
//     loading1,
//     error1,
//     data1: databuyHealthPolicy,
//     previousData1,
//   } = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
//     fetchPolicy: 'cache-first',
//     skip: new Set(initLoadRef.current).size >= 3,
//     onCompleted: (_) => {
//       initLoadRef.current = [...initLoadRef.current, 1];
//     },
//   });
// ////console.log('100_databuyHealthPolicy',databuyHealthPolicy)
// ////console.log('previousData1',previousData1)
  const {
    loading: loadingFinancerDropDownDetails,
    error: errorFinancerDropdownDetails,
    data: dataFinancerDropdownDetails,
  } = useQuery(FINANCER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
    },
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 2];
    },
  });

  const {
    loading: loadingPreviousInsurerDetails,
    error: errorPreviousInsurerDetails,
    data: dataPreviousInsurerDetails,
  } = useQuery(PREVIOUS_INSURER_COMPANY_LIST, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
    },
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 3];
    },
  });

  if (
    loading ||
    loadingFinancerDropDownDetails ||
    loadingPreviousInsurerDetails||
    loadingdrop
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }
  if (
    error ||
    errorFinancerDropdownDetails ||
    errorPreviousInsurerDetails
  ) {
    return (
      <div className="min-h-screen">
        <Error
          error={
            error ||
            errorFinancerDropdownDetails ||
            errorPreviousInsurerDetails
          }
        />
      </div>
    );
  }
  const  buyMotorPolicy  = dataBuyMotorPolicy
    ? dataBuyMotorPolicy
    : previousData;
  const { quoteData, intermediaryDetails } = buyMotorPolicy;
  const { PRD_FinancerAgreementType, PRD_IsYourVehicle } =
    dataFinancerDropdownDetails;
  const { rolloverCompanyList } = dataPreviousInsurerDetails;
  const { PRD_NomiRelationWithMemb, PRD_ApointRelationWithMinNomi } = dropDownDetails;
    const MINOR_THRESHOLD_AGE = 18;

  const initialValues = {
  //   previousInsuranceAndClaims: {
  //     previousPolicyDetails: {
  //       previousInsurerName: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousPolicyDetails
  //         ?.previousInsurerName
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName}`
  //         : quoteData?.prevInsurance?.insurerName
  //         ? `${quoteData?.prevInsurance?.insurerName}`
  //         : rolloverCompanyList && rolloverCompanyList?.length > 0
  //         ? rolloverCompanyList[0]?.code
  //         : '',
  //       expiringPolicyNumber: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousPolicyDetails
  //         ?.expiringPolicyNumber
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber}`
  //         : quoteData?.prevInsurance?.policyNumber
  //         ? `${quoteData?.prevInsurance?.policyNumber}`
  //         : '',
  //       policyCoverType: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousPolicyDetails
  //         ?.policyCoverType
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyCoverType}`
  //         : quoteData?.policyCoverType
  //         ? `${quoteData?.policyCoverType}`
  //         : '',
  //       policyStartDate: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousPolicyDetails
  //         ?.policyStartDate
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyStartDate}`
  //         : quoteData?.policyStartDate
  //         ? `${quoteData?.policyStartDate}`
  //         : '',
  //       policyExpiryDate: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousPolicyDetails
  //         ?.policyExpiryDate
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate}`
  //         : quoteData?.policyExpiryDate
  //         ? `${quoteData?.policyExpiryDate}`
  //         : '',
  //       policyTenure: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousPolicyDetails
  //         ?.policyTenure
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenure}`
  //         : quoteData?.policyTenure
  //         ? `${quoteData?.policyTenure}`
  //         : '',
  //       policyTenureValue: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousPolicyDetails
  //         ?.policyTenureValue
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue}`
  //         : quoteData?.policyTenureValue
  //         ? `${quoteData?.policyTenureValue}`
  //         : '',
  //     },
  //     previousClaims: {
  //       totalClaimCount: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousClaims
  //         ?.totalClaimCount
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimCount}`
  //         : quoteData?.totalClaimCount
  //         ? `${quoteData?.totalClaimCount}`
  //         : '',
  //       totalClaimCountValue: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousClaims
  //         ?.totalClaimCountValue
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimCountValue}`
  //         : quoteData?.totalClaimCountValue
  //         ? `${quoteData?.totalClaimCountValue}`
  //         : '',
  //       totalClaimAmount: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousClaims
  //         ?.totalClaimAmount
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimAmount}`
  //         : quoteData?.totalClaimAmount
  //         ? `${quoteData?.totalClaimAmount}`
  //         : '',
  //       previousYearNCBSlab: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousClaims
  //         ?.previousYearNCBSlab
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab}`
  //         : quoteData?.previousYearNCBSlab
  //         ? `${quoteData?.previousYearNCBSlab}`
  //         : '',
  //       noOfClaimsYear1: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousClaims
  //         ?.noOfClaimsYear1
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear1}`
  //         : quoteData?.noOfClaimsOneYear
  //         ? `${quoteData?.noOfClaimsOneYear}`
  //         : '',
  //       noOfClaimsYear2: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousClaims
  //         ?.noOfClaimsYear2
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear2}`
  //         : quoteData?.noOfClaimsTwoYears
  //         ? `${quoteData?.noOfClaimsTwoYears}`
  //         : '',
  //       noOfClaimsYear3: buyMotorPolicy?.additionalTabDetails
  //         ?.previousInsuranceAndClaims?.previousClaims
  //         ?.noOfClaimsYear3
  //         ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear3}`
  //         : quoteData?.noOfClaimsThreeYears
  //         ? `${quoteData?.noOfClaimsThreeYears}`
  //         : '',
  //     },
  //   },
    nomineeDetails: {
      nomineeName: buyMotorPolicy?.buyHealthPolicy
        ?.nomineeDetails?.[0]?.name
        ? `${buyMotorPolicy?.buyHealthPolicy?.nomineeDetails?.[0]?.name}`
        : '',
      nomineeDob: buyMotorPolicy?.buyHealthPolicy?.nomineeDetails?.[0]?.dob
        ? `${buyMotorPolicy?.buyHealthPolicy?.nomineeDetails?.[0]?.dob}`
        : '',
      relationshipWithNominee: buyMotorPolicy?.buyHealthPolicy
        ?.nomineeDetails?.[0]?.relationshipWithInsured
        ? `${buyMotorPolicy?.buyHealthPolicy?.nomineeDetails?.[0]?.relationshipWithInsured}`
        : '',
      nameOfAppointee: buyMotorPolicy?.buyHealthPolicy
        ?.nomineeDetails?.[0]?.nameOfAppointee
        ? `${buyMotorPolicy?.buyHealthPolicy?.nomineeDetails?.[0]?.nameOfAppointee}`
        : '',
      relationshipWithAppointee: buyMotorPolicy?.buyHealthPolicy
        ?.nomineeDetails?.[0]?.relationshipWithAppointee
        ? `${buyMotorPolicy?.buyHealthPolicy?.nomineeDetails?.[0]?.relationshipWithAppointee}`
        : '',
    },
    prevInsuranceDetails:{
      insurername: buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.Name_of_Insurer
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.Name_of_Insurer}`
        : '',
        policynumber: buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.Existing_PA_Policy_Number
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.Existing_PA_Policy_Number}`
        : '',
        suminsured: buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.Existing_PA_Policy_Sum_Insured
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.Existing_PA_Policy_Sum_Insured}`
        : '',
        startdate: buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.Existing_PA_Policy_Start_Date
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.Existing_PA_Policy_Start_Date}`
        : '',
        enddate: buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.Existing_PA_Policy_End_Date
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.Existing_PA_Policy_End_Date}`
        : '',
        pastinsurername : buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.pastinsurername
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastinsurername}`
        : '',
        pastAddress:buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.pastAddress
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastAddress}`
        : '',
        pastpolicynumber:buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.pastpolicynumber
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastpolicynumber}`
        : '',
        paststartdate:buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.paststartdate
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.paststartdate}`
        : '',
        pastenddate:buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.pastenddate
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastenddate}`
        : '',
        pastpropertydescription:buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.pastpropertydescription
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastpropertydescription}`
        : '',
        // pastcauseofloss:buyMotorPolicy?.buyHealthPolicy
        // ?.prevInsuranceDetails?.[0]?.pastpropertydescription
        // ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastcauseofloss}`
        // : '',
        pastlosslocation:buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.pastlosslocation
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastlosslocation}`
        : '',
        pastamountofloss:buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.pastamountofloss
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastamountofloss}`
        : '',
        pastsuminsured:buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.pastsuminsured
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastsuminsured}`
        : '',
        pastpremium:buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.pastpremium
        ? `${buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastpremium}`
        : '',
        pastOldData:buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.pastOldData === true
        ? buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastOldData
        : false,
        pastDeleted:buyMotorPolicy?.buyHealthPolicy
        ?.prevInsuranceDetails?.[0]?.pastDeleted === true
        ? buyMotorPolicy?.buyHealthPolicy?.prevInsuranceDetails?.[0]?.pastDeleted
        : false,
    },
    financeDetails: {
      vehicleOwned: buyMotorPolicy?.additionalTabDetails
        ?.financeDetails?.vehicleOwned
        ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.vehicleOwned}`
        : buyMotorPolicy?.quoteData?.financerName
        ? getDomainData(
            PRD_IsYourVehicle,
            'financed',
            'value',
            'code',
          )
        : PRD_IsYourVehicle && PRD_IsYourVehicle?.length > 0
        ? PRD_IsYourVehicle[0]?.code
        : '',
      financerDetails: {
        financerName: buyMotorPolicy?.additionalTabDetails
          ?.financeDetails?.financerDetails?.financerName
          ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.financerName}`
          : quoteData?.financerName
          ? `${quoteData?.financerName}`
          : '',
        financerAddress: buyMotorPolicy?.additionalTabDetails
          ?.financeDetails?.financerDetails?.financerAddress
          ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.financerAddress}`
          : '',
        financerAgreementType: buyMotorPolicy?.additionalTabDetails
          ?.financeDetails?.financerDetails?.financerAgreementType
          ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.financerAgreementType}`
          : '',
        loanAccountNumber: buyMotorPolicy?.additionalTabDetails
          ?.financeDetails?.financerDetails?.loanAccountNumber
          ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.loanAccountNumber}`
          : '',
        fileNumber: buyMotorPolicy?.additionalTabDetails
          ?.financeDetails?.financerDetails?.fileNumber
          ? `${buyMotorPolicy?.additionalTabDetails?.financeDetails?.financerDetails?.fileNumber}`
          : '',
      },
    },
  };

  const validate = (values) => {
    let errors = {};
    errors.nomineeDetails ={};
    errors.prevInsuranceDetails = {};
    //console.log('validate values add page -->',values)
      //console.log('values data', values)
      if (!values.nomineeDetails.nomineeName) {
        errors.nomineeDetails.nomineeName = '* Required';
      }
      if (
        values.nomineeDetails.nomineeName &&
        values.nomineeDetails.nomineeName.match(/\d/)
      ) {
        errors.nomineeDetails.nomineeName =
          '* Name cannot be alphanumeric';
        }
      if (!values.nomineeDetails.nomineeDob) {
        errors.nomineeDetails.nomineeDob = '* Required';
      }
      //nomineeDetails.nomineeDob
      
      if (values.nomineeDetails.nomineeDob) {
        if (
          moment(
            values.nomineeDetails.nomineeDob,
            'DD/MM/YYYY',
          ).isAfter()
        ) {
          errors.nomineeDetails.nomineeDob =
            '* Date of Birth cannot be a future date';
        }
      }
      //nomineeDetails.relationshipWithNominee
      if (!values.nomineeDetails.relationshipWithNominee) {
        errors.nomineeDetails.relationshipWithNominee = '* Required';
      }

      //nomineeDetails.nameOfAppointee  &&  nomineeDetails.relationshipWithAppointee

      if (
        values.nomineeDetails.nomineeDob &&
        moment(new Date(), 'DD/MM/YYYY').diff(
          moment(values.nomineeDetails.nomineeDob, 'DD/MM/YYYY'),
          'years',
        ) < MINOR_THRESHOLD_AGE
      ) {
        if (!values.nomineeDetails.nameOfAppointee) {
          //console.log('minor case')
          errors.nomineeDetails.nameOfAppointee =
            '* Required';
          } else if (
            !values.nomineeDetails.nameOfAppointee.match(
              /^[a-zA-Z ]*$/,
            )
          ) {
            errors.nomineeDetails.nameOfAppointee =
              '* Name can be alphabets only';
          } 
        if (
          !values.nomineeDetails.relationshipWithAppointee
        ) {
          errors.nomineeDetails.relationshipWithAppointee = '* Required';
        }
      }
      //Previous insurance value
      if(buyMotorPolicy?.buyHealthPolicy.quoteData.quotationType.toString() === 'New Business')
      {
      if (
        !values?.prevInsuranceDetails?.pastinsurername
      ) {
        errors.prevInsuranceDetails.pastinsurername = '* Required';
      }
      if (
        !values?.prevInsuranceDetails?.pastAddress
      ) {
        errors.prevInsuranceDetails.pastAddress  = '* Required';
      }
      if (
        !values?.prevInsuranceDetails?.pastpolicynumber
      ) {
        errors.prevInsuranceDetails.pastpolicynumber = '* Required';
      }
      if (
        !values?.prevInsuranceDetails?.paststartdate
      ) {
        errors.prevInsuranceDetails.paststartdate = '* Required';
      }
      if (
        !values?.prevInsuranceDetails?.pastenddate
      ) {
        errors.prevInsuranceDetails.pastenddate = '* Required';
        }
      }
      let error_count = 0;
    
      error_count += Object.keys(errors.nomineeDetails)
        .length;
   
    if (error_count === 0) {
      errors = {};
    }
    //console.log("errors : ",errors);
    return errors;
  };

  const AdditionalDetailform = ({ validate }) => {
    const { values } = useQuantaFormikContext();
    const data = [
      // quoteData?.businessType?.toLowerCase() === 'roll over' &&
      // quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
      //   'yes'
      //   ? {
      //       title: (
      //         <Text severity="info" type="title">
      //           Previous Insurance & Claims Details
      //         </Text>
      //       ),
      //       grid_type: 'data',
      //       grid_data: [
      //         {
      //           text: (
      //             <Text
      //               type="large"
      //               severity="info"
      //               className="font-semibold"
      //             >
      //               Previous Policy
      //             </Text>
      //           ),
      //           colSpan: repeat,
      //         },
      //         {
      //           label: (
      //             <>
      //               Previous Insurer Name{' '}
      //               {/* <Text severity={'error'}>*</Text> */}
      //             </>
      //           ),
      //           colSpan: repeat === repeatForMobile ? repeat : 1,
      //           text: (
      //             <div className={'mt-1'}>
      //               <QuantaSelect
      //                 name={
      //                   'previousInsuranceAndClaims.previousPolicyDetails.previousInsurerName'
      //                 }
      //                 disabled={
      //                   buyMotorPolicy?.proposalNumber?.length > 0
      //                 }
      //                 data={
      //                   rolloverCompanyList &&
      //                   rolloverCompanyList?.length > 0
      //                     ? rolloverCompanyList?.map((company) => {
      //                         return {
      //                           label: company?.value
      //                             ? `${company?.value}`
      //                             : '',
      //                           value: company?.code
      //                             ? `${company?.code}`
      //                             : '',
      //                         };
      //                       })
      //                     : []
      //                 }
      //                 searchable={true}
      //                 size={'full'}
      //               />
      //             </div>
      //           ),
      //         },
      //         {
      //           label: (
      //             <>
      //               Expiring Policy Number{' '}
      //               {/* <Text severity={'error'}>*</Text> */}
      //             </>
      //           ),
      //           colSpan: repeat === repeatForMobile ? repeat : 1,
      //           text: (
      //             <div className={'mt-1'}>
      //               <QuantaInput
      //                 name={
      //                   'previousInsuranceAndClaims.previousPolicyDetails.expiringPolicyNumber'
      //                 }
      //                 disabled={
      //                   buyMotorPolicy?.proposalNumber?.length > 0
      //                 }
      //                 size={'full'}
      //               />
      //             </div>
      //           ),
      //         },
      //         {
      //           label: 'Policy/Cover Type',
      //           text: values?.previousInsuranceAndClaims
      //             ?.previousPolicyDetails?.policyCoverType,
      //         },
      //         {
      //           label: 'Policy Start Date',
      //           text: values?.previousInsuranceAndClaims
      //             ?.previousPolicyDetails?.policyStartDate,
      //         },
      //         {
      //           label: 'Policy Expiry Date',
      //           text: values?.previousInsuranceAndClaims
      //             ?.previousPolicyDetails?.policyExpiryDate,
      //         },
      //         {
      //           label: 'Policy Tenure',
      //           text: values?.previousInsuranceAndClaims
      //             ?.previousPolicyDetails?.policyTenure,
      //         },
      //         {
      //           text: (
      //             <Text
      //               severity="info"
      //               type="large"
      //               className="font-semibold"
      //             >
      //               Previous Claims
      //             </Text>
      //           ),
      //           colSpan: repeat,
      //           className: 'mt-3',
      //         },
      //         values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue
      //           ?.toLowerCase()
      //           ?.search('annual') !== -1
      //           ? {
      //               label: 'Total Claim Count',
      //               text: values?.previousInsuranceAndClaims
      //                 ?.previousClaims?.totalClaimCount,
      //             }
      //           : null,
      //         values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue
      //           ?.toLowerCase()
      //           ?.search('long term') !== -1
      //           ? {
      //               label: 'No of Claims in Year 1',
      //               text: values?.previousInsuranceAndClaims
      //                 ?.previousClaims?.noOfClaimsYear1,
      //             }
      //           : null,
      //         values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue
      //           ?.toLowerCase()
      //           ?.search('long term') !== -1
      //           ? {
      //               label: 'No of Claims in Year 2',
      //               text: values?.previousInsuranceAndClaims
      //                 ?.previousClaims?.noOfClaimsYear2,
      //             }
      //           : null,
      //         values?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue
      //           ?.toLowerCase()
      //           ?.search('long term') !== -1
      //           ? {
      //               label: 'No of Claims in Year 3',
      //               text: values?.previousInsuranceAndClaims
      //                 ?.previousClaims?.noOfClaimsYear3,
      //             }
      //           : null,
      //         {
      //           label: 'Total Claim Amount',
      //           text: CurrencyFormater(
      //             values?.previousInsuranceAndClaims?.previousClaims
      //               ?.totalClaimAmount,
      //             true,
      //             false,
      //             branding,
      //           ),
      //         },
      //         values?.previousInsuranceAndClaims?.previousClaims
      //           ?.previousYearNCBSlab
      //           ? {
      //               label: 'Previous Year NCB Slab',
      //               text: `${values?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab} %`,
      //             }
      //           : null,
      //       ].filter((d) => d),
      //     }
      //   : null,
      // {
      //   title: 'Nominee Details',
      //   grid_data: [
      //     {
      //       type: 'text',
      //       disabled: buyMotorPolicy?.proposalNumber?.length>0,
      //       colSpan: repeat === repeatForMobile ? repeat: 1,
      //       label: (
      //         <>
      //           Nominee Name <Text severity="error"> {getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual'?'*':''}</Text>
      //         </>
      //       ),
      //       name: 'nomineeDetails.nomineeName',
      //     },
      //     {
      //       type: 'date',
      //       disabled: buyMotorPolicy?.proposalNumber?.length>0,
      //       colSpan: repeat === repeatForMobile ? repeat: 1,
      //       label: (
      //         <>
      //           Nominee Date of Birth <Text severity="error"> {getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual'?'*':''}</Text>
      //         </>
      //       ),
      //       name: 'nomineeDetails.nomineeDob',
      //       onDataChange: (val,setFieldValue) => {
      //         if (
      //           moment(new Date(), 'DD/MM/YYYY').diff(
      //             moment(val, 'DD/MM/YYYY'),
      //             'years',
      //           ) >= MINOR_THRESHOLD_AGE
      //         ) {
      //           setFieldValue(
      //             `nomineeDetails.nameOfAppointee`,
      //             '',
      //           );
      //           setFieldValue(
      //             `nomineeDetails.relationshipWithAppointee`,
      //             '',
      //           );
      //         }
      //       }
      //     },
      //     {
      //       type: 'select',
      //       size: 'large',
      //       disabled: buyMotorPolicy?.proposalNumber?.length>0,
      //       colSpan: repeat === repeatForMobile ? repeat: 1,
      //       label: (
      //         <>
      //           Relationship <Text severity="error"> {getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual'?'*':''}</Text>
      //         </>
      //       ),
      //       name: 'nomineeDetails.relationshipWithNominee',
      //       data: (PRD_NomiRelationWithMemb && PRD_NomiRelationWithMemb?.length>0)?PRD_NomiRelationWithMemb?.map((relationship) => {
      //         return {
      //           label: relationship?.value ? relationship?.value: '',
      //           value: relationship?.code ? relationship?.code: ''
      //         }
      //       }):[],
      //     },
      //     {
      //       type: 'text',
      //       disabled: buyMotorPolicy?.proposalNumber?.length>0,
      //       colSpan: repeat === repeatForMobile ? repeat: 1,
      //       label: (
      //         <>
      //           Name of Appointee <Text severity="error"> {`${(getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual' && (moment(new Date(), 'DD/MM/YYYY').diff(
      //         moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
      //         'years',
      //       ) < MINOR_THRESHOLD_AGE))?'*':''}`}</Text>
      //         </>
      //       ),
      //       name: 'nomineeDetails.nameOfAppointee',
      //       disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
      //         moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
      //         'years',
      //       ) >= MINOR_THRESHOLD_AGE || buyMotorPolicy?.proposalNumber?.length>0),
      //     },
      //     {
      //       type: 'select',
      //       size: 'large',
      //       colSpan: repeat === repeatForMobile ? repeat: 1,
      //       label: (
      //         <>
      //           Relationship with Appointee{' '}
      //           <Text severity="error"> {`${(getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual' && (moment(new Date(), 'DD/MM/YYYY').diff(
      //         moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
      //         'years',
      //       ) < MINOR_THRESHOLD_AGE))?'*':''}`}</Text>
      //         </>
      //       ),
      //       name: 'nomineeDetails.relationshipWithAppointee',
      //       disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
      //         moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
      //         'years',
      //       ) >= MINOR_THRESHOLD_AGE || buyMotorPolicy?.proposalNumber?.length>0),
      //       data: (PRD_ApointRelationWithMinNomi && PRD_ApointRelationWithMinNomi?.length>0)?PRD_ApointRelationWithMinNomi?.map((relationship) => {
      //         return {
      //           label: relationship?.value ? relationship?.value : '',
      //           value: relationship?.code ? relationship?.code : ''
      //         }
      //       }):[],
      //     },
      //   ],
      // },
      {
        title: 'Nominee Details',
        grid_data: [
          {
            type: 'text',
            maxLength:100,
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Nominee Name{' '}
              <Text severity={'error'}>*</Text> 
              </>
            ),
            name: 'nomineeDetails.nomineeName',
          },
          {
            type: 'date',
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Nominee Date of Birth{' '}
              <Text severity={'error'}>*</Text> 
              </>
            ),
            name: 'nomineeDetails.nomineeDob',
            onDataChange: (val, setFieldValue) => {
              if (
                moment(new Date(), 'DD/MM/YYYY').diff(
                  moment(val, 'DD/MM/YYYY'),
                  'years',
                ) >= MINOR_THRESHOLD_AGE
              ) {
                setFieldValue(
                  `nomineeDetails.nameOfAppointee`,
                  '',
                );
                setFieldValue(
                  `nomineeDetails.relationshipWithAppointee`,
                  '',
                );
              }
            }
          },
          {
            type: 'select',
            size: 'large',
            maxLength:50,
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label:
              (
                <>
                  Relationship{' '}
                  <Text severity={'error'}>*</Text> 
                </>
              ),
            name: 'nomineeDetails.relationshipWithNominee',
            data: (PRD_NomiRelationWithMemb && PRD_NomiRelationWithMemb?.length > 0) ? PRD_NomiRelationWithMemb?.map((relationship) => {
              return {
                label: relationship?.value ? relationship?.value : '',
                value: relationship?.code ? relationship?.code : ''
              }
            }) : [],
          },
          {
            type: 'text',
            maxLength:100,
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Name of Appointee <Text severity="error"> {`${
                  // (getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual' && 
                  (moment(new Date(), 'DD/MM/YYYY').diff(
                    moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
                    'years',
                  ) < MINOR_THRESHOLD_AGE) ? '*' : ''}`}</Text>
              </>
            ),
            name: 'nomineeDetails.nameOfAppointee',
            disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
              moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
              'years',
            ) >= MINOR_THRESHOLD_AGE || buyMotorPolicy?.proposalNumber?.length > 0),
          },
          {
            type: 'select',
            size: 'large',
            maxLength:50,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Relationship with Appointee{' '}
                <Text severity="error"> {`${
                  // (getDomainData(customerTypeList,buyMotorPolicy?.proposerDetails?.customerType,'code','value')?.toLowerCase() === 'individual'
                  (moment(new Date(), 'DD/MM/YYYY').diff(
                    moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
                    'years',
                  ) < MINOR_THRESHOLD_AGE) ? '*' : ''}`}</Text>
              </>
            ),
            name: 'nomineeDetails.relationshipWithAppointee',
            disabled: (moment(new Date(), 'DD/MM/YYYY').diff(
              moment(values?.nomineeDetails?.nomineeDob, 'DD/MM/YYYY'),
              'years',
            ) >= MINOR_THRESHOLD_AGE || buyMotorPolicy?.proposalNumber?.length > 0),
            data: (PRD_ApointRelationWithMinNomi && PRD_ApointRelationWithMinNomi?.length > 0) ? PRD_ApointRelationWithMinNomi?.map((relationship) => {
              return {
                label: relationship?.value ? relationship?.value : '',
                value: relationship?.code ? relationship?.code : ''
              }
            }) : [],
          },
        ]
      },
      // {
      //   title: 'PA Details',
      //   grid_data: [
      //     {
      //       type: 'select',
      //       maxLength:100,
      //       disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           Previous Insurer Name{' '}
                
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.insurername',
      //       data: rolloverCompanyList &&
      //       rolloverCompanyList?.length > 0
      //         ? rolloverCompanyList?.map((company) => {
      //             return {
      //               label: company?.value
      //                 ? `${company?.value}`
      //                 : '',
      //               value: company?.code
      //                 ? `${company?.code}`
      //                 : '',
      //             };
      //           })
      //         : [],
      //       searchable:true
      //     },
      //     {
      //       type: 'text',
      //       maxLength:50,
      //       disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           Existing PA policy number{' '}
                
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.policynumber',
      //     },
      //     {
      //       type: 'number',
      //       maxLength:12,
      //       onKeyDown: (evt) =>
      //             (evt.key === 'e' || evt.key === '-') &&
      //             evt.preventDefault(),
      //           iconPre: <FontAwesomeIcon icon={faRupeeSign} />,
      //           disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           PA policy sum insured{' '}
                
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.suminsured',
      //     },
      //     {
      //       type: 'date',
      //       disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           Start Date{' '}
                
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.startdate',
            
      //     },
      //     {
      //       type: 'date',
      //       disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           End Date{' '}
                
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.enddate',
      //     }

      //   ]
      // },
      // {
      //   title: 'Previous Insurance Details',
      //   grid_data: [
      //     {
      //       type: 'select',
      //       maxLength:100,
      //       disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           Previous Insurer Name{' '}
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.pastinsurername',
      //       data: rolloverCompanyList &&
      //       rolloverCompanyList?.length > 0
      //         ? rolloverCompanyList?.map((company) => {
      //             return {
      //               label: company?.value
      //                 ? `${company?.value}`
      //                 : '',
      //               value: company?.code
      //                 ? `${company?.code}`
      //                 : '',
      //             };
      //           })
      //         : [],
      //       searchable:true
      //     },
      //     {
      //       type: 'textarea',
      //       maxLength:200,
      //       disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           Previous Insurer Address{' '}
                
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.pastAddress',
      //     },
      //     {
      //       type: 'text',
      //       maxLength:30,
      //       disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           Existing Previous policy number{' '}
                
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.pastpolicynumber',
      //     },
      //     {
      //       type: 'date',
      //       disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           Start Date{' '}
                
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.paststartdate',
      //     },
      //     {
      //       type: 'date',
      //       disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           End Date{' '}
                
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.pastenddate',
            
      //     },
          // {
      //       type: 'text',
      //       maxLength:30,
          //   disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
          //   colSpan: repeat === repeatForMobile ? repeat : 1,
          //   label: (
          //     <>
      //           Description of Property {' '}
                
          //     </>
          //   ),
      //       name: 'prevInsuranceDetails.pastpropertydescription',
          // },
      //     // {
      //     //   type: 'select',
      //     //   disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //     //   colSpan: repeat === repeatForMobile ? repeat : 1,
      //     //   label: (
      //     //     <>
      //     //       Cause of Loss {' '}
      //     //       
      //     //     </>
      //     //   ),
      //     //   name: 'prevInsuranceDetails.pastcauseofloss',
      //     // },
      //     {
      //       type: 'text',
      //       disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           Loss Location {' '}
                
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.pastlosslocation',
      //     },
      //     {
      //       type: 'number',
      //       maxLength:12,
      //       onKeyDown: (evt) =>
      //             (evt.key === 'e' || evt.key === '-') &&
      //             evt.preventDefault(),
      //           iconPre: <FontAwesomeIcon icon={faRupeeSign} />,
      //           disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
      //       label: (
      //         <>
      //           Amount of Loss{' '}
                
      //         </>
      //       ),
      //       name: 'prevInsuranceDetails.pastamountofloss',
      //     },
      //     {
      //       type: 'number',
      //       maxLength:12,
      //       onKeyDown: (evt) =>
      //             (evt.key === 'e' || evt.key === '-') &&
      //             evt.preventDefault(),
      //           iconPre: <FontAwesomeIcon icon={faRupeeSign} />,
          //   disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
          //   label: (
          //     <>
      //           Previous policy sum insured{' '}
                
          //     </>
          //   ),
      //       name: 'prevInsuranceDetails.pastsuminsured',
          // },
          // {
      //       type: 'number',
      //       maxLength:12,
      //       onKeyDown: (evt) =>
      //             (evt.key === 'e' || evt.key === '-') &&
      //             evt.preventDefault(),
      //           iconPre: <FontAwesomeIcon icon={faRupeeSign} />,
          //   disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //       colSpan: repeat === repeatForMobile ? repeat : 1,
          //   label: (
          //     <>
      //           Premium(Rs.){' '}
                
          //     </>
          //   ),
      //       name: 'prevInsuranceDetails.pastpremium',
      //     },
      //     // {
      //     //   type: 'checkbox',
      //     //   disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //     //   label: (
      //     //     <>
      //     //       Old Data{' '}
      //     //     </>
      //     //   ),
      //     //   name: `prevInsuranceDetails.pastOldData`,
      //     //   className: 'mt-10',
      //     // },
      //     // {
      //     //   type: 'checkbox',
      //     //   disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
      //     //   label: (
      //     //     <>
      //     //       Deleted{' '}
      //     //     </>
      //     //   ),
      //     //   name: `prevInsuranceDetails.pastDeleted`,
      //     //   className: 'mt-10',
            
      //     // }
      //   ]
          // }


      // {
      //   title: 'Finance Details',
      //   grid_data: [
      //     {
      //       type: 'radiogroup',
      //       label: <>Is the Vehicle</>,
      //       colSpan: repeat,
      //       name: 'financeDetails.vehicleOwned',
      //       disabledGlobal:
      //         buyMotorPolicy?.proposalNumber?.length > 0,
      //       data:
      //         PRD_IsYourVehicle && PRD_IsYourVehicle?.length > 0
      //           ? PRD_IsYourVehicle?.filter((isYourVehicle)=>{
      //             if(isYourVehicle?.value ==='Self Owned'){
      //               return {
      //                 label: isYourVehicle?.value
      //                   ? isYourVehicle?.value
      //                   : '',
      //                 value: isYourVehicle?.code
      //                   ? isYourVehicle?.code
      //                   : '',
      //               };
      //             }
      //           })
      //           .map((isYourVehicle) => {
      //               return {
      //                 label: isYourVehicle?.value
      //                   ? isYourVehicle?.value
      //                   : '',
      //                 value: isYourVehicle?.code
      //                   ? isYourVehicle?.code
      //                   : '',
      //               };
      //             })
      //           : [],
      //     },
          
      //     values?.financeDetails?.vehicleOwned?.toLowerCase() ===
      //     'financed'
      //       ? {
      //           type: 'text',
      //           colSpan: repeat === repeatForMobile ? 2 : 1,
      //           label: <>Financer Name</>,
      //           name: 'financeDetails.financerDetails.financerName',
      //           onKeyDown: (evt) => {
      //             if (
      //               (evt?.target?.value?.toString()?.endsWith(' ') &&
      //                 evt?.key === ' ') ||
      //               (evt?.target?.value?.toString()?.length === 0 &&
      //                 evt?.key === ' ')
      //             ) {
      //               evt.preventDefault();
      //             }
      //           },
      //           disabled: buyMotorPolicy?.proposalNumber?.length > 0,
      //         }
      //       : null,
      //     values?.financeDetails?.vehicleOwned?.toLowerCase() ===
      //     'financed'
      //       ? {
      //           type: 'text',
      //           colSpan: 2,
      //           label: <>Financer Address</>,
      //           name: 'financeDetails.financerDetails.financerAddress',
      //           disabled: buyMotorPolicy?.proposalNumber?.length > 0,
      //           colSpan: 2,
      //         }
      //       : null,
      //     values?.financeDetails?.vehicleOwned?.toLowerCase() ===
      //     'financed'
      //       ? {
      //           type: 'select',
      //           size: 'large',
      //           colSpan: repeat === repeatForMobile ? 2 : 1,
      //           label: <>Financer Agreement Type </>,
      //           name: 'financeDetails.financerDetails.financerAgreementType',
      //           disabled: buyMotorPolicy?.proposalNumber?.length > 0,
      //           data:
      //             PRD_FinancerAgreementType &&
      //             PRD_FinancerAgreementType?.length > 0
      //               ? PRD_FinancerAgreementType?.map(
      //                   (financerAgreementType) => {
      //                     return {
      //                       label: financerAgreementType?.value
      //                         ? `${financerAgreementType?.value}`
      //                         : '',
      //                       value: financerAgreementType?.code
      //                         ? `${financerAgreementType?.code}`
      //                         : '',
      //                     };
      //                   },
      //                 )
      //               : [],
      //         }
      //       : null,
      //     values?.financeDetails?.vehicleOwned?.toLowerCase() ===
      //     'financed'
      //       ? {
      //           type: 'text',
      //           colSpan: repeat === repeatForMobile ? 2 : 1,
      //           label: <>Loan Account Number </>,
      //           name: 'financeDetails.financerDetails.loanAccountNumber',
      //           disabled: buyMotorPolicy?.proposalNumber?.length > 0,
      //         }
      //       : null,
      //     values?.financeDetails?.vehicleOwned?.toLowerCase() ===
      //     'financed'
      //       ? {
      //           type: 'text',
      //           colSpan: repeat === repeatForMobile ? 2 : 1,
      //           label: <>File Number</>,
      //           name: 'financeDetails.financerDetails.fileNumber',
      //           disabled: buyMotorPolicy?.proposalNumber?.length > 0,
      //         }
      //       : null,
      //   ].filter((d) => d),
      // },
    ].filter((b) => b);
    const PAdata = [{title: 'PA Details',
    grid_data: [
      {
        type: 'select',
        maxLength:100,
        disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
        colSpan: repeat === repeatForMobile ? repeat : 1,
        label: (
          <>
            Previous Insurer Name{' '}
          </>
        ),
        name: 'prevInsuranceDetails.insurername',
        data: rolloverCompanyList &&
        rolloverCompanyList?.length > 0
          ? rolloverCompanyList?.map((company) => {
              return {
                label: company?.value
                  ? `${company?.value}`
                  : '',
                value: company?.code
                  ? `${company?.code}`
                  : '',
              };
            })
          : [],
        searchable:true
      },
      {
        type: 'text',
        maxLength:50,
        disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
        colSpan: repeat === repeatForMobile ? repeat : 1,
        label: (
          <>
            Existing PA policy number{' '}
          </>
        ),
        name: 'prevInsuranceDetails.policynumber',
      },
      {
        type: 'number',
        maxLength:12,
        onKeyDown: (evt) =>
              (evt.key === 'e' || evt.key === '-') &&
              evt.preventDefault(),
            iconPre: <FontAwesomeIcon icon={faRupeeSign} />,
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
        colSpan: repeat === repeatForMobile ? repeat : 1,
        label: (
          <>
            PA policy sum insured{' '}
          </>
        ),
        name: 'prevInsuranceDetails.suminsured',
      },
      {
        type: 'date',
        disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
        colSpan: repeat === repeatForMobile ? repeat : 1,
        label: (
          <>
            Start Date{' '}
          </>
        ),
        name: 'prevInsuranceDetails.startdate',
      },
      {
        type: 'date',
        disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
        colSpan: repeat === repeatForMobile ? repeat : 1,
        label: (
          <>
            End Date{' '}
          </>
        ),
        name: 'prevInsuranceDetails.enddate',
      }
    ]
  ,}]
    const previousdata = [{
        title: 'Previous Insurance Details',
        grid_data: [
          {
            type: 'select',
            maxLength:100,
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Previous Insurer Name{' '}
              </>
            ),
            name: 'prevInsuranceDetails.pastinsurername',
            data: rolloverCompanyList &&
            rolloverCompanyList?.length > 0
              ? rolloverCompanyList?.map((company) => {
                  return {
                    label: company?.value
                      ? `${company?.value}`
                      : '',
                    value: company?.code
                      ? `${company?.code}`
                      : '',
                  };
                })
              : [],
            searchable:true
          },
          {
            type: 'textarea',
            maxLength:200,
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Previous Insurer Address{' '}
              </>
            ),
            name: 'prevInsuranceDetails.pastAddress',
          },
          {
            type: 'text',
            maxLength:30,
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Existing Previous policy number{' '}
              </>
            ),
            name: 'prevInsuranceDetails.pastpolicynumber',
          },
          {
            type: 'date',
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Start Date{' '}
              </>
            ),
            name: 'prevInsuranceDetails.paststartdate',
          },
          {
            type: 'date',
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                End Date{' '}
              </>
            ),
            name: 'prevInsuranceDetails.pastenddate',
          },
          {
            type: 'text',
            maxLength:30,
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Description of Property {' '}
              </>
            ),
            name: 'prevInsuranceDetails.pastpropertydescription',
          },
          // {
          //   type: 'select',
          //   disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
          //   colSpan: repeat === repeatForMobile ? repeat : 1,
          //   label: (
          //     <>
          //       Cause of Loss {' '}
          //       
          //     </>
          //   ),
          //   name: 'prevInsuranceDetails.pastcauseofloss',
          // },
          {
            type: 'text',
            disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Loss Location {' '}
              </>
            ),
            name: 'prevInsuranceDetails.pastlosslocation',
          },
          {
            type: 'number',
            maxLength:12,
            onKeyDown: (evt) =>
                  (evt.key === 'e' || evt.key === '-') &&
                  evt.preventDefault(),
                iconPre: <FontAwesomeIcon icon={faRupeeSign} />,
                disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Amount of Loss{' '}
              </>
            ),
            name: 'prevInsuranceDetails.pastamountofloss',
          },
          {
            type: 'number',
            maxLength:12,
            onKeyDown: (evt) =>
                  (evt.key === 'e' || evt.key === '-') &&
                  evt.preventDefault(),
                iconPre: <FontAwesomeIcon icon={faRupeeSign} />,
                disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Previous policy sum insured{' '}
              </>
            ),
            name: 'prevInsuranceDetails.pastsuminsured',
          },
          {
            type: 'number',
            maxLength:12,
            onKeyDown: (evt) =>
                  (evt.key === 'e' || evt.key === '-') &&
                  evt.preventDefault(),
                iconPre: <FontAwesomeIcon icon={faRupeeSign} />,
                disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
            colSpan: repeat === repeatForMobile ? repeat : 1,
            label: (
              <>
                Premium(Rs.){' '}
              </>
            ),
            name: 'prevInsuranceDetails.pastpremium',
          },
          // {
          //   type: 'checkbox',
          //   disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
          //   label: (
          //     <>
          //       Old Data{' '}
          //     </>
          //   ),
          //   name: `prevInsuranceDetails.pastOldData`,
          //   className: 'mt-10',
          // },
          // {
          //   type: 'checkbox',
          //   disabled: buyMotorPolicy?.buyHealthPolicy?.proposalNumber?.length > 0,
          //   label: (
          //     <>
          //       Deleted{' '}
          //     </>
          //   ),
          //   name: `prevInsuranceDetails.pastDeleted`,
          //   className: 'mt-10',
          // }
        ]
    }]
    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      textType: 'normal',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };
    const other_props1 = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      textType: 'normal',
      useExpandablePaper: true,
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };
    return (
      <>
        <QuantaForm className="space-y-4 mt-3">
          <MixedGridGroup {...{ data, ...other_props }} />
          <MixedGridGroup {...{ data:PAdata, ...other_props1 }} />
          <MixedGridGroup {...{ data:previousdata, ...other_props1 }} />
        </QuantaForm>
      </>
    );
  };

  const getVehicleData = (Data) =>{
          //console.log("inside vehicle data ", Data);
          let arr =[];
          for(let i =0 ; i < Data.VehicleType.length ; i++){
            arr.push( {
              VehicleType : Data.VehicleType[i],
              RegistrationNumber : Data.RegistrationNumber[i],
              VehicleMakeModel :Data.VehicleMakeModel[i],
              PUCStartDate : Data.PUC_Start_Date[i],
              PUCEndDate :Data.PUC_End_Date[i],
              EngineNo : Data.EngineNo[i],
              ChasisNo : Data.ChasisNo[i],
              PolicyNumber : Data.PolicyNumber[i], 
            });
          }
          //console.log("inside getVehicledata arr ",arr);
          return arr;
  }
//console.log(`911_quote status`,buyMotorPolicy?.buyHealthPolicy?.quotationStatus)
//console.log(`911_vehicledata1`,buyMotorPolicy?.buyHealthPolicy?.quoteData?.VehicleType[0])
  const getCalculatePremiumForProposalVariables = (values) => {
    let arr = [];
    const { warningMsg, ...restPremium } =
    buyMotorPolicy?.buyHealthPolicy?.planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() === params?.plan_name?.toLowerCase(),
          )?.premium;
          const { isNewCustomer,ciuType,isCRNVerified, ...restProposerMetaData } =
          buyMotorPolicy?.buyHealthPolicy?.proposerDetailsMeta;
          buyMotorPolicy?.buyHealthPolicy?.insuredDetails.map((r,idx) => {
            arr.push( {
              VehicleType : buyMotorPolicy?.buyHealthPolicy?.quoteData.members?.[idx]?.relationship?.toString(),
              RegistrationNumber : r.vehicleRegNo.part1 + r.vehicleRegNo.part2 +
                                    r.vehicleRegNo.part3 + r.vehicleRegNo.part4,
              VehicleMakeModel :r.VehicleMake+'-'+ r.VehicleModel,
              EngineNo : r.EngineNo,
              ChasisNo : r.ChasisNo,
            });
          })
          //console.log('calculate arr',arr)
    // buyMotorPolicy?.coverData?.rawRiskData?.forEach((r) => {
    //   let covers = [];
    //   r.covers
    //     .filter(
    //       (c) =>
    //         buyMotorPolicy?.coverData?.addOnCovers[c?.name]?.selected,
    //     )
    //     .forEach((c) => {
    //       const { selected, attributes, ...rest } = c;
    //       let attributesArr = [];
    //       c?.attributes?.forEach((attribute) => {
    //         attributesArr.push({
    //           ...attribute,
    //           value: attribute?.showOnScreen
    //             ? `${
    //                 buyMotorPolicy?.coverData?.addOnCovers[
    //                   `${c?.name}`
    //                 ][`attributes`][`${attribute?.name}`]
    //               }`
    //             : `${attribute?.defaultValue}`,
    //         });
    //       });
    //       covers.push({
    //         ...rest,
    //         attributes: [...attributesArr],
    //       });
    //     });
    //   if (covers?.length !== 0) {
    //     riskInput.push({
    //       riskType: r?.riskType,
    //       covers,
    //     });
    //   }
    // });
    return {
      input: {
        proposerDetails: {
          ...restProposerMetaData,
          //...buyMotorPolicy?.buyHealthPolicy?.proposerDetails,
          //proposerDetailsMeta:buyMotorPolicy?.buyHealthPolicy?.proposerDetailsMeta,
          ...buyMotorPolicy?.buyHealthPolicy?.proposerDetails,
          isThinCustomer: false,
          isCRNVerified : false
          //isCRNVerified : isCRNVerified === null ? false : 
                //isCRNVerified === "" ? false: isCRNVerified,
        },
        //insuredDetails: buyMotorPolicy?.buyHealthPolicy?.insuredDetails,
        insuredDetails:arr,
        plan: {
          name: params?.plan_name,
          code: params?.plan_code,
          premium:restPremium,
          // premium: buyMotorPolicy?.buyHealthPolicy?.planData?.plans?.find(
          //   (plan) =>
          //     plan?.name?.toLowerCase() === plan_name?.toLowerCase(),
          // )?.premium,
        },
        intermediary: {
          intermediaryCode: buyMotorPolicy?.buyHealthPolicy?.intermediaryDetails.code,
          locationCode:buyMotorPolicy?.buyHealthPolicy?.intermediaryDetails.location,
          fieldUserCode:buyMotorPolicy?.buyHealthPolicy?.intermediaryDetails.fieldUserCode,
        },
        zone: buyMotorPolicy?.buyHealthPolicy?.quoteData?.location?.zone?.trim(),
        quotationType: buyMotorPolicy?.buyHealthPolicy?.quotationType,
        sumInsured: parseFloat(
          buyMotorPolicy?.buyHealthPolicy?.quoteData?.cover?.sum_insured,
        ),
        startDate: Date.now(),
        startTime: '00:00',
        tenure: buyMotorPolicy?.buyHealthPolicy?.quoteData?.cover?.tenure,
        coverType: buyMotorPolicy?.buyHealthPolicy?.quoteData?.cover?.type,
        productCode: product_code,
        isExistingEmployee:
        buyMotorPolicy?.buyHealthPolicy?.quoteData?.isExistingEmployee?.toLowerCase() ===
          'yes'
            ? true
            : false,
        existingPolicyNumber:
          buyMotorPolicy?.buyHealthPolicy?.existingPolicyNumber,
        employeeNumber:
          buyMotorPolicy?.buyHealthPolicy?.proposerDetails?.employeeNumber,
        proposerPincode:
          buyMotorPolicy?.buyHealthPolicy?.quoteData?.location?.pincode,
          nomineeDetails:{
              name: values?.nomineeDetails.nomineeName,
      dob: values?.nomineeDetails.nomineeDob,
      relationshipWithInsured: values?.nomineeDetails.relationshipWithNominee,
      insuredRelationship: values?.nomineeDetails.relationshipWithNominee,
      nameOfAppointee: values?.nomineeDetails.nameOfAppointee,
      relationshipWithAppointee: values?.nomineeDetails.relationshipWithAppointee,
          },
      prevInsuranceDetails :{
        Name_of_Insurer: values?.prevInsuranceDetails?.insurername,
        Existing_PA_Policy_Number: values?.prevInsuranceDetails?.policynumber,
        Existing_PA_Policy_Sum_Insured: values?.prevInsuranceDetails?.suminsured,
        Existing_PA_Policy_Start_Date: values?.prevInsuranceDetails?.startdate,
        Existing_PA_Policy_End_Date: values?.prevInsuranceDetails?.enddate,
        pastinsurername:values?.prevInsuranceDetails?.pastinsurername,
        pastAddress:values?.prevInsuranceDetails?.pastAddress,
        pastpolicynumber:values?.prevInsuranceDetails?.pastpolicynumber,
        paststartdate:values?.prevInsuranceDetails?.paststartdate,
        pastenddate:values?.prevInsuranceDetails?.pastenddate,
        pastpropertydescription:values?.prevInsuranceDetails?.pastpropertydescription,
        pastcauseofloss:'loss',
        pastlosslocation:values?.prevInsuranceDetails?.pastlosslocation,
        pastamountofloss:values?.prevInsuranceDetails?.pastamountofloss,
        pastsuminsured:values?.prevInsuranceDetails?.pastsuminsured,
        pastpremium:values?.prevInsuranceDetails?.pastpremium,
        pastOldData:values?.prevInsuranceDetails?.pastOldData,
        pastDeleted:values?.prevInsuranceDetails?.pastDeleted
      }
      },
    };
    
  };
  const submitInsuredArr = (values) => {
    let submitArr = [];
      submitArr.push({
        name: values?.nomineeDetails.nomineeName,
  dob: values?.nomineeDetails.nomineeDob,
  relationshipWithInsured: values?.nomineeDetails.relationshipWithNominee,
  insuredRelationship: values?.nomineeDetails.relationshipWithNominee,
  nameOfAppointee: values?.nomineeDetails.nameOfAppointee,
  relationshipWithAppointee: values?.nomineeDetails.relationshipWithAppointee,
      });
    
    
    //console.log('1340_submitarr',submitArr)
    return submitArr;
  };
  const prevInsuredArr = (values)=>
  {
    let submitArr = [];
      submitArr.push({
        Name_of_Insurer: values?.prevInsuranceDetails?.insurername,
        Existing_PA_Policy_Number: values?.prevInsuranceDetails?.policynumber,
        Existing_PA_Policy_Sum_Insured: values?.prevInsuranceDetails?.suminsured,
        Existing_PA_Policy_Start_Date: values?.prevInsuranceDetails?.startdate,
        Existing_PA_Policy_End_Date: values?.prevInsuranceDetails?.enddate,
        pastinsurername:values?.prevInsuranceDetails?.pastinsurername,
        pastAddress:values?.prevInsuranceDetails?.pastAddress,
        pastpolicynumber:values?.prevInsuranceDetails?.pastpolicynumber,
        paststartdate:values?.prevInsuranceDetails?.paststartdate,
        pastenddate:values?.prevInsuranceDetails?.pastenddate,
        pastpropertydescription:values?.prevInsuranceDetails?.pastpropertydescription,
        //pastcauseofloss:values?.prevInsuranceDetails?.pastcauseofloss,
        pastlosslocation:values?.prevInsuranceDetails?.pastlosslocation,
        pastamountofloss:values?.prevInsuranceDetails?.pastamountofloss,
        pastsuminsured:values?.prevInsuranceDetails?.pastsuminsured,
        pastpremium:values?.prevInsuranceDetails?.pastpremium,
        pastOldData:values?.prevInsuranceDetails?.pastOldData,
        pastDeleted:values?.prevInsuranceDetails?.pastDeleted
  
      });
    
    //console.log('1239_submitarr',submitArr)
    return submitArr; 
  }
  const onSubmit = async (values) => {
    //let nom = submitInsuredArr(values)
    if (Object.values(validate(values)).length === 0) {
      //console.log('return if section',values)
    if (!buyMotorPolicy?.buyHealthPolicy?.proposalNumber) {
      try {
        //console.log('1239_Additional details values',values)
        updateBuyHealthPolicy({
          nomineeDetails :
          submitInsuredArr(values),
          prevInsuranceDetails:
          prevInsuredArr(values)
        })
        //console.log('on submit buyMotorPolicy',buyMotorPolicy)
        setParentAlerts([]);
        const calculatePremiumForProposalTWQuery = fetchQuery({
          query: CALCULATE_PREMIUM_FOR_PROPOSAL,
          variables: getCalculatePremiumForProposalVariables(values),
        });
        
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setCustomLoadingMessage('Calculating Premium');
        setLoadingStep(true);
        const { data } = await calculatePremiumForProposalTWQuery;
        setLoadingStep(false);
        setCustomLoadingMessage(null);
        if (data?.calculatePremiumForProposalTW?.warningMsg) {
          if (
            buyMotorPolicy?.premiumData?.totalPremium !== null &&
            buyMotorPolicy?.premiumData?.totalPremium?.toString() !==
              data?.calculatePremiumForProposalTW?.totalPremium?.toString()
          ) {
            setParentAlerts([
              {
                id: 1,
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      Your premium has been updated successfully
                    </Text>
                  </div>
                ),
                type: 'info',
                timeout: null,
                disableClose: false,
              },
              {
                id: 2,
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      {
                        data?.calculatePremiumForProposalTW
                          ?.warningMsg
                      }
                    </Text>
                  </div>
                ),
                type: 'warning',
                timeout: null,
                disableClose: false,
              },
            ]);
          } else if (
            buyMotorPolicy?.premiumData?.totalPremium === null
          ) {
            setParentAlerts([
              {
                id: 1,
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      Your premium has been updated successfully
                    </Text>
                  </div>
                ),
                type: 'info',
                timeout: null,
                disableClose: false,
              },
              {
                id: 2,
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      {
                        data?.calculatePremiumForProposalTW
                          ?.warningMsg
                      }
                    </Text>
                  </div>
                ),
                type: 'warning',
                timeout: null,
                disableClose: false,
              },
            ]);
          } else {
            setParentAlerts([
              {
                id: Date.now(),
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      {
                        data?.calculatePremiumForProposalTW
                          ?.warningMsg
                      }
                    </Text>
                  </div>
                ),
                type: 'warning',
                timeout: null,
                disableClose: false,
              },
            ]);
          }
        } else {
          if (
            buyMotorPolicy?.premiumData?.totalPremium !== null &&
            buyMotorPolicy?.premiumData?.totalPremium?.toString() !==
              data?.calculatePremiumForProposalTW?.totalPremium?.toString()
          ) {
            setParentAlerts([
              {
                id: Date.now(),
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      Your premium has been updated successfully
                    </Text>
                  </div>
                ),
                type: 'info',
                timeout: null,
                disableClose: false,
              },
            ]);
          } else if (
            buyMotorPolicy?.premiumData?.totalPremium === null
          ) {
            setParentAlerts([
              {
                id: Date.now(),
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      Your premium has been updated successfully
                    </Text>
                  </div>
                ),
                type: 'info',
                timeout: null,
                disableClose: false,
              },
            ]);
          } else {
            setParentAlerts([]);
          }
        }
        updateBuyMotorPolicy({
          premiumData: {
            ...data?.calculatePremiumForProposalTW,
            tenure:
              buyMotorPolicy?.quoteData?.tenure ||
              buyMotorPolicy?.quoteData?.premiumData?.tenure,
          },
        });
        return true;
      } catch (error) {
        setLoadingStep(false);
        setCustomLoadingMessage(null);
        setParentAlerts([
          {
            id: Date.now(),
            header: 'Error calculating premium',
            content: (
              <div className="flex flex-col w-full h-full">
                <Text type="normal">{error?.message}</Text>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        return false;
      }
    } else {
      return true;
    }
  }
  ////console.log('return else section')
  return false
  };

  return (
    <div>
      <QuantaFormik
        innerRef={props.forwardedRef}
        enableReinitialize={true}
        {...{
          initialValues,
          validate,
          onSubmit,
          validator: () => ({}),
        }}
      >
        <AdditionalDetailform {...{ validate }} />
      </QuantaFormik>
    </div>
  );
}
